// extracted by mini-css-extract-plugin
module.exports = {"bookmark-view-icon":"bookmarkViewIcon-m__bookmark-view-icon__1Sac1"};